
import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { OverallDevices } from '../../_models/OverallDevices';
import { Device } from '../../_models/Device';
import { environment } from 'src/environments/environment';


let httpHeaders = new HttpHeaders()
.set( 'Authorization', 'Bearer ' + localStorage.getItem('token'))
.set('Content-Type', 'application/json');   
let options = {
headers: httpHeaders
};  

const httpOptions = {
  headers: new HttpHeaders({
    'Authorization': 'Bearer ' + localStorage.getItem('token')
  })
}


@Injectable({
  providedIn: 'root'
})
export class DeviceService {

  private baseUrl = environment.apiUrl + 'Device/';
  constructor(private http: HttpClient) { }

  GetOverAllDeviceStatus(): Observable<HttpResponse<any>> {
    return this.http.get<OverallDevices>(this.baseUrl + 'OverallDevicesStatus',{
      headers: httpHeaders,
      observe: 'response'
    });
  }

  // GetDeviceList(): Observable<Device[]> {
  //   return this.http.get<Device[]>(this.baseUrl + 'GetListDevices', httpOptions);
  // }
  GetDeviceList(): Observable<HttpResponse<any>> {
    return this.http.get<HttpResponse<any>>(this.baseUrl + 'GetListDevices',{
      headers: httpHeaders,
      observe: 'response'
    });
  }

  GetActiveDeviceList(): Observable<HttpResponse<any>> {
    return this.http.get<HttpResponse<any>>(this.baseUrl + 'GetActiveDevices',{
      headers: httpHeaders,
      observe: 'response'
    });
  }
  SetSync(Devid: any): Observable<HttpResponse<any>> {
    return this.http.post<HttpResponse<any>>(this.baseUrl + 'setSync?DevId=' + Devid, null, httpOptions);
  }
  ClearLogData(Devid: any): Observable<HttpResponse<any>> {
    return this.http.post<HttpResponse<any>>(this.baseUrl + 'ClearLogData?DevId=' + Devid, null,{
      headers: httpHeaders,
      observe: 'response'
    });
  }

  ResetMachine(Devid: any): Observable<HttpResponse<any>> {
    return this.http.post<HttpResponse<any>>(this.baseUrl + 'ResetMachine?DevId=' + Devid, null,{
      headers: httpHeaders,
      observe: 'response'
    });
  }

  UpdateDeviceName(deviceName: any,DevID:any): Observable<HttpResponse<any>> {
    return this.http.post<HttpResponse<any>>(this.baseUrl + 'UpdateDeviceName?deviceName=' + deviceName+'&mDevID='+DevID, null,{
      headers: httpHeaders,
      observe: 'response'
    });
  }
  UpdateServerInfo(DevId: any, ServerIp: any, port: any) {
    // tslint:disable-next-line: max-line-length
    return this.http.post(this.baseUrl + 'UpdateServerInfo?DevId=' + DevId + '&serverIP=' + ServerIp + '&port=' + port, null, httpOptions);
  }
}
